<!-- Board Display Page -->

<!-- Loading State -->
@if (isLoading()) {
  <div class="h-screen bg-station-cream flex items-center justify-center">
    <div class="text-center">
      <div
        class="inline-block w-12 h-12 border-4 border-signal-orange border-t-transparent rounded-full animate-spin mb-4"
      ></div>
      <p class="text-lg text-rail-gray">Loading board...</p>
    </div>
  </div>
}

<!-- Error State -->
@else if (error()) {
  <div class="h-screen bg-station-cream flex items-center justify-center">
    <div class="text-center max-w-md px-6">
      <div class="text-6xl mb-4">❌</div>
      <h1 class="text-2xl font-bold mb-4">{{ error() }}</h1>
      <p class="text-rail-gray mb-6">
        The board you're looking for doesn't exist or has been removed.
      </p>
      <a
        href="/"
        class="inline-block px-6 py-3 bg-signal-orange text-white rounded-lg font-semibold hover:bg-signal-orange/90 transition-all"
      >
        Go Home
      </a>
    </div>
  </div>
}

<!-- Passcode Required State -->
@else if (showPasscodeForm()) {
  <div class="h-screen bg-station-cream flex items-center justify-center">
    <div class="max-w-md w-full px-6">
      <div class="bg-white border-2 border-border-subtle rounded-xl p-8">
        <div class="text-center mb-6">
          <div class="text-5xl mb-4">🔒</div>
          <h1 class="text-2xl font-bold mb-2">Passcode Required</h1>
          <p class="text-rail-gray">
            This board is protected. Please enter the passcode to view it.
          </p>
        </div>

        <!-- Passcode Form -->
        <form (submit)="submitPasscode(); $event.preventDefault()">
          <div class="mb-6">
            <label class="block font-semibold text-xs uppercase tracking-wide text-rail-gray mb-2">
              Passcode
            </label>
            <input
              type="password"
              [(ngModel)]="passcode"
              name="passcode"
              placeholder="Enter passcode"
              class="w-full px-4 py-3 border-2 border-border-subtle rounded focus:outline-none focus:border-signal-orange focus:ring-4 focus:ring-signal-orange/10 transition-all"
              [class.border-red-500]="passcodeError()"
              autofocus
            />
            @if (passcodeError()) {
              <p class="text-red-500 text-sm mt-2">{{ passcodeError() }}</p>
            }
          </div>

          <button
            type="submit"
            class="w-full px-6 py-3 bg-signal-orange text-white rounded-lg font-semibold hover:bg-signal-orange/90 transition-all"
          >
            View Board
          </button>
        </form>
      </div>
    </div>
  </div>
}

<!-- Board Display State -->
@else if (board()) {
  <div class="h-screen">
    <app-split-flap-board
      [config]="board()!.config"
      [messages]="board()!.messages"
      [muted]="board()!.soundEnabled === false"
      (displayMessage)="onDisplayMessage($event)"
      [showHeader]="true"
      [showFooter]="true"
      [headerText]="board()!.title || 'FlippyBoards.com'"
      [footerText]="'Powered by our supporters • Subscribe to become one and get rid of this message'"
    />
  </div>
}
